import {
  ActiveStatus,
  ActiveStatusGetter,
  INodeWithTrade,
} from './Utils';

const getActive = (
    // Note: this is the list of categories NOT selected:
    deselectedCategories: number[],
    rcaThreshold: number): ActiveStatusGetter => {

  const deselectedCategoriesSet = new Set<number>(deselectedCategories);

  return ({section, rca}: INodeWithTrade) => {
    if (rca < rcaThreshold) {
      return ActiveStatus.NotExported;
    } else if (deselectedCategoriesSet.has(section)) {
      return ActiveStatus.Deselected;
    } else {
      return ActiveStatus.Active;
    }
  };
};

export default getActive;
